"use client";
import type { DatadogRum } from "@datadog/browser-rum";
import { telemetryUrl } from "./urls";

let rumPromise: Promise<DatadogRum> | null = null;
let client: DatadogRum | null = null;
const queuedActions: {
  name: string;
  context: Record<string, string | number | boolean | null | undefined>;
}[] = [];
export type DatadogRumConfig = {
  applicationId: string;
  clientToken: string;
  site?: string | undefined;
  service: string;
  environment?: string | undefined;
  version?: string | undefined;
};
let configuration: DatadogRumConfig | null = null;

export function configureDatadogRum(config: DatadogRumConfig | null) {
  configuration = config;
}

export function initializeDatadogRum(): Promise<DatadogRum> | null {
  const config = configuration;

  if (!config) return null;

  rumPromise ??= import("@datadog/browser-rum").then(({ datadogRum }) => {
    datadogRum.init({
      applicationId: config.applicationId,
      clientToken: config.clientToken,
      site: config.site ?? "datadoghq.com",
      service: config.service,
      env: config.environment,
      version: config.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: false,
      trackLongTasks: false,
      defaultPrivacyLevel: "mask-user-input",
      beforeSend(event) {
        event.view.url = telemetryUrl(event.view.url);

        if (event.view.referrer)
          event.view.referrer = telemetryUrl(event.view.referrer);

        if (event.type === "resource")
          event.resource.url = telemetryUrl(event.resource.url);

        return true;
      },
    });
    client = datadogRum;

    for (const action of queuedActions)
      datadogRum.addAction(action.name, action.context);

    queuedActions.length = 0;
    return datadogRum;
  });
  return rumPromise;
}

export function captureDatadogRumAction({
  name,
  context,
}: {
  name: string;
  context: Record<string, string | number | boolean | null | undefined>;
}) {
  if (!configuration) return;

  if (client) client.addAction(name, context);
  else queuedActions.push({ name, context });
}
